export * from './skeleton.directive';
